import { createBrowserHistory } from 'history';
import { configureStore } from '@livingsecurity/shared';
import rootReducer from './ConfigureReducers';

export const history = createBrowserHistory();

const store = configureStore(rootReducer, { name: 'LivingSecurity - Root' });

export default store;
